import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Button } from "reactstrap";
import SpinnerLabel from "common/components/spinner-label";
import EditClient from "./edit-client";
import ShowClient from "./show-client";

const propTypes = {
  updateCallback: PropTypes.func.isRequired,
  isProcessing: PropTypes.bool.isRequired,
  isUpdating: PropTypes.bool.isRequired,
  deleteCallback: PropTypes.func.isRequired,
  isDeleting: PropTypes.bool.isRequired,
  toggleEdit: PropTypes.func.isRequired,
  showEdit: PropTypes.bool.isRequired,
  client: PropTypes.shape({
    id: PropTypes.number.isRequired,
    full_name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired
  }).isRequired
};

const Client = ({
  updateCallback,
  isProcessing,
  isUpdating,
  deleteCallback,
  isDeleting,
  toggleEdit,
  showEdit,
  client
}) => {
  const handleToggleEdit = event => {
    event.preventDefault();
    toggleEdit(client.id);
  };

  return (
    <Row className="d-flex align-items-center mb-2">
      {showEdit ? (
        <EditClient
          isProcessing={isProcessing}
          isUpdating={isUpdating}
          updateCallback={updateCallback}
          client={client}
        />
      ) : (
        <ShowClient client={client} toggleEdit={handleToggleEdit} />
      )}
      <Col xs="auto" className="px-0">
        <Button
          color="link"
          disabled={isProcessing}
          className="p-0 border-0 mr-3"
          onClick={deleteCallback}
        >
          <SpinnerLabel spin={isDeleting} label="remove" spinningLabel="removing" />
        </Button>
      </Col>
    </Row>
  );
};

Client.propTypes = propTypes;

export default Client;
